import { t } from "@/lib/i18n";

export const StickyCta = ({ onClick }) => (
  <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-black/95 border-t border-[#27272A] px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]" data-testid="sticky-cta-bar">
    <button type="button" data-testid="sticky-create-ride-button" onClick={onClick} className="ff-btn-primary w-full h-16 text-base uppercase">
      {t("CEDI O CARICA UNA CORSA")}
    </button>
  </div>
);
